'use client'

import {
  Select as SelectMain,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SelectGroup
} from "@/components/ui/select"
import { Label } from "@/components/ui/label"
import { getBorderRadiusClass } from "@/utils/util"

/**
 * Renders a select component.
 *
 * @param {Object} props - The component props.
 * @param {string} props.value - The selected value.
 * @param {function} props.onChange - The function to handle value change.
 * @param {Array} [props.items=defaultItems] - The array of select items.
 * @param {string} [props.placeholder='Сонгоно уу'] - The placeholder text.
 * @param {string} [props.className] - The additional CSS class name.
 * @returns {JSX.Element} The select component.
 */

interface SelectProps {
  value?: string
  onChange?: (_value: string) => void
  items?: Array<{ value: string; label: string; desc?: string }>
  placeholder?: string
  label?: string
  className?: string
  container?: string
  border?: 'none' | 'sm' | 'md' | 'lg' | 'xl'
  required?: boolean;
  [key: string]: any
}

export default function Select({ value, onChange, label, items = defaultItems, placeholder = 'Сонгоно уу', className, container, border, required = false }: SelectProps){
  const borderRadius = border ? getBorderRadiusClass(border) : 'rounded-md'

  return (
    <div className={`flex flex-col w-full gap-1.5 ${container}`}>
      { label && (<Label>{label}{required && (<span className="text-red-500 -ml-1">*</span>)}</Label>) }
      <SelectMain value={value ?? ''} onValueChange={onChange}>
        <SelectTrigger className={`w-full ${className} ${borderRadius}`}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {items.map((item, index) => (
              <SelectItem key={index} value={item.value}>{item.label} {item.desc && (<span className="text-muted-foreground">{item.desc}</span>)}</SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </SelectMain>
    </div>
  )
}

const defaultItems = [
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
  { value: 'system', label: 'System' }
]